import React from 'react';
import { applePayButtonRendered, expressCheckoutWidgetButtonClicked } from '@wix/bi-logger-cashier-ugc/v2';
import { BiOriginProduct, BiPmApplePay, BiPpWp } from '../../Hoc/BiLogger/constants';
import { getPageFingerprint } from '../../../utils/sentry/getPageFingerprint';
import { amountToLong } from '../../../utils/amountToLong';
import { Props } from './controller.connect';
import { ApplePayView } from './view';

export class ApplePayController extends React.Component<Props> {
  componentDidMount() {
    const { meta, requestShipping } = this.props.topProps;
    this.props.biLogger.report(
      applePayButtonRendered({
        pageType: getPageFingerprint(),
        cartId: meta.cartId,
        msid: meta.siteId,
        paymentmethod: BiPmApplePay,
        paymentProvider: BiPpWp,
        requestShipping,
        visitorId: meta.visitorId,
      }),
    );
  }
  onClick = () => {
    const {
      paymentAmount,
      paymentLabel,
      currency,
      requestShipping,
      shippingMethods,
      paymentBreakdown,
      meta,
      domain,
      onShippingContactSelected,
      onShippingMethodSelected,
      onPaymentAuthorized,
      onPaymentMethodSelectedInApplePay,
    } = this.props.topProps;

    this.props.biLogger.report(
      expressCheckoutWidgetButtonClicked({
        amountLong: amountToLong(paymentAmount),
        appInstanceId: meta.appInstanceId,
        currency,
        paymentProvider: BiPpWp,
        paymentmethod: BiPmApplePay,
        productId: meta.productId,
        origin: BiOriginProduct,
      }),
    );
    this.props.startApplePayFlow({
      ...this.props,
      meta,
      sessionId: this.props.sessionId,
      paymentAmount,
      paymentLabel,
      currencyCode: currency,
      requestShipping,
      shippingMethods,
      paymentBreakdown,
      domain,
      onShippingContactSelected,
      onShippingMethodSelected,
      onPaymentMethodSelectedInApplePay,
      onPaymentAuthorized,
    });
  };
  render() {
    return (
      <ApplePayView
        height={this.props.topProps.buttonStyle.height}
        locale={this.props.topProps.locale}
        color={this.props.color}
        shape={this.props.topProps.buttonStyle.shape}
        onClick={this.onClick}
      ></ApplePayView>
    );
  }
}
